import {connect} from 'react-redux'
import Template from "./Template";
import {setHeader} from "../../Store/actionTypes";

const mapStateToProps = state => {
    return {
        userData: state.userData,
        header: state.header,
        appState: state.appState,
        loginState: state.loginState,
    }
};

const mapHeaderDispatchToProps = dispatch => {
    return {
        setHeader: (title, icon) => {
            dispatch(setHeader(title, icon))
        }
    }
};

const Container = connect(
    mapStateToProps,
    mapHeaderDispatchToProps
)(Template);

export {mapStateToProps, mapHeaderDispatchToProps}

export default Container;
